import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function SplashScreen() {
  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/home');
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return (
    <motion.div 
      className="h-full w-full flex flex-col items-center justify-center"
      style={{
        background: 'linear-gradient(160deg, #0D1B2A 0%, #0E3A3A 100%)'
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="text-center"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <h1 className="font-display text-5xl font-black tracking-tighter leading-none">
          <span className="text-secondary">So</span>
          <span className="text-primary">View</span>
          <br />
          <span className="text-secondary">FX</span>
        </h1>
        <p className="mt-3 text-xs text-muted-foreground tracking-[0.3em] uppercase">
          Visualisation extérieure
        </p>
      </motion.div>
      
      <motion.div
        className="mt-10 w-2 h-2 rounded-full bg-secondary"
        animate={{
          scale: [0.8, 1.2, 0.8],
          opacity: [0.3, 1, 0.3]
        }}
        transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: 'easeInOut'
        }}
      />
    </motion.div>
  );
}
